export const DYNAMIC_CLIENT_NB_CARDHOLDERS_CATMAN_KPIS = [
    'nb_cardholders_previous',
    'nb_cardholders_lost_previous',
    'nb_cardholders_regular',
    'nb_cardholders_regular_previous',
    'nb_cardholders_new',
    'nb_cardholders',
    'nb_cardholders_evolution',
    'nb_cardholders_delta',
    'nb_cardholders_lost_in_brand_only_previous',
    'nb_cardholders_lost_in_category_for_you_previous',
    'nb_cardholders_lost_to_category_all_competitors_previous',
    'nb_cardholders_new_in_brand_only',
    'nb_cardholders_new_in_category_for_you',
    'nb_cardholders_new_to_category_all_competitors',
    'nb_cardholder_by_movement',
    'nb_cardholder_by_movement_evolution'
];
export const DYNAMIC_CLIENT_NB_CARDHOLDERS_KPI_DISPLAY_NAME = [
    'dynamic_client_nb_cardholders_previous',
    'dynamic_client_nb_cardholders_lost_previous',
    'dynamic_client_nb_cardholders_regular',
    'dynamic_client_nb_cardholders_regular_previous',
    'dynamic_client_nb_cardholders_new',
    'dynamic_client_nb_cardholders',
    'dynamic_client_nb_cardholders_evolution',
    'dynamic_client_nb_cardholders_delta',
    'dynamic_client_nb_cardholders_lost_in_brand_only_previous',
    'dynamic_client_nb_cardholders_lost_in_category_for_you_previous',
    'dynamic_client_nb_cardholders_lost_to_category_all_competitors_previous',
    'dynamic_client_nb_cardholders_new_in_brand_only',
    'dynamic_client_nb_cardholders_new_in_category_for_you',
    'dynamic_client_nb_cardholders_new_to_category_all_competitors',
    'nb_cardholder_by_movement',
    'nb_cardholder_by_movement_comparison',
    'nb_cardholder_by_movement_benchmark'
];
export const DYNAMIC_CLIENT_NB_CARDHOLDERS_KPI_MAPPING = {
    dynamic_client_nb_cardholders_previous: 'nb_cardholders_previous',
    dynamic_client_nb_cardholders_lost_previous: 'nb_cardholders_lost_previous',
    dynamic_client_nb_cardholders_regular: 'nb_cardholders_regular',
    dynamic_client_nb_cardholders_regular_previous: 'nb_cardholders_regular_previous',
    dynamic_client_nb_cardholders_new: 'nb_cardholders_new',
    dynamic_client_nb_cardholders: 'nb_cardholders',
    dynamic_client_nb_cardholders_evolution: 'nb_cardholders_evolution',
    dynamic_client_nb_cardholders_delta: 'nb_cardholders_delta',
    dynamic_client_nb_cardholders_lost_in_brand_only_previous: 'nb_cardholders_lost_in_brand_only_previous',
    dynamic_client_nb_cardholders_lost_in_category_for_you_previous: 'nb_cardholders_lost_in_category_for_you_previous',
    dynamic_client_nb_cardholders_lost_to_category_all_competitors_previous: 'nb_cardholders_lost_to_category_all_competitors_previous',
    dynamic_client_nb_cardholders_new_in_brand_only: 'nb_cardholders_new_in_brand_only',
    dynamic_client_nb_cardholders_new_in_category_for_you: 'nb_cardholders_new_in_category_for_you',
    dynamic_client_nb_cardholders_new_to_category_all_competitors: 'nb_cardholders_new_to_category_all_competitors',
    nb_cardholder_by_movement: 'nb_cardholder_by_movement',
    nb_cardholder_by_movement_comparison: 'nb_cardholders_evolution',
    nb_cardholder_by_movement_benchmark: 'nb_cardholders_evolution'
};
export const DYNAMIC_CLIENT_NB_CARDHOLDERS_DATA_TABLE_KPI_DISPLAY_NAME = [
    'nb_cardholder_by_movement',
    'nb_cardholder_by_movement_benchmark'
];
//# sourceMappingURL=nbCardholders.kpis.js.map